module.exports = __webpack_public_path__ + "media/images/athletes/3553-a2aa758324d35ef2032abf111f8b54df.png";